export default "__VITE_ASSET__NXuHoWbO__"